import { Component, OnInit, Input, forwardRef, ViewChild, HostBinding, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ElementRef } from '@angular/core/src/linker/element_ref';

@Component({
  selector: 'app-textarea-counter',
  templateUrl: './textarea-counter.component.html',
  styleUrls: ['./textarea-counter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaCounterComponent),
      multi: true,
    }
  ]
})
export class TextareaCounterComponent implements OnInit, ControlValueAccessor {
  @Input('placeholder') placeholder: string;
  @Input('maxLength') maxLength: number;
  @ViewChild('messagefield') messageField: any;
  disabled: boolean;
  message: string;
  change = (_: any) => { };

  constructor() {
    this.maxLength = 255;
    this.placeholder = 'Enter your message';
  }

  ngOnInit() {
  }

  @HostBinding('tabindex')
  getTabIndex() {
    return -1;
  }

  @HostListener('focus')
  focusHandler() {
    this.messageField.nativeElement.focus();
  }

  writeValue(obj: any): void {
    this.message = obj;
  }

  registerOnChange(fn: any): void {
    this.change = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  setMessage() {
    this.change(this.message);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/textarea-counter/textarea-counter.component.ts